import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class QuestionHistory extends Model<Schemas['questionHistory'], Models> {}
